import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop'; 
import LandingPage from './components/LandingPage';
import Marketplace from './components/Marketplace';
import SellPage from './components/SellPage';
import BuyPage from './components/BuyPage';
import HowItWorksPage from './components/HowItWorksPage';
import TermsPage from './components/Terms';
import AdminDashboard from './components/Admin/AdminDashboard';
import LoginPage from './components/Auth/LoginPage';
import AuthActionPage from './components/Auth/AuthActionPage';
import UserDashboard from './components/Dashboard/UserDashboard';
import PrivacyPage from './components/PrivacyPage';
import SeoLandingPage from './components/SeoLandingPage';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/cadeaubonnen-kopen" element={<SeoLandingPage />} />
        <Route path="/cadeaubonnen-verkopen" element={<SeoLandingPage />} />
        <Route path="/giftcards/:slug" element={<SeoLandingPage />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/sell" element={<SellPage />} />
        <Route path="/buy" element={<BuyPage />} />
        <Route path="/buy/return" element={<BuyPage />} />
        <Route path="/buy/failed" element={<BuyPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/order/success" element={<BuyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/action" element={<AuthActionPage />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
